module.exports = __webpack_public_path__ + "media/svg/icon_fit_grey-576b027f.svg";